import { useTranslation } from 'react-i18next'
import { ScheduleVirtualClassroomSession } from 'modules/simulatorTrainings/common/components'
import { ScheduleSimulatorSessionContainer } from 'modules/simulatorTrainings/common/containers'
import { namespace } from 'modules/simulatorTrainings/common/localization'
import {
  SimulatorTrainingScheduleSession,
  SimulatorTrainingSessionType,
} from 'modules/simulatorTrainings/common/types'
import { SessionList } from './ScheduleSessions.styled'

const I18_PATH = `${namespace}:simulatorTraining`

type ScheduleSessionsProps = {
  sessions: SimulatorTrainingScheduleSession[]
  onStart: (sessionId: Guid) => void
  onStartSimulation: (sessionId: Guid) => void
  onStopSimulation: (sessionId: Guid) => void
}

const ScheduleSessions: React.FC<ScheduleSessionsProps> = props => {
  const { t } = useTranslation()
  const { sessions, onStart, onStartSimulation, onStopSimulation } = props
  const sessionTypes: Record<SimulatorTrainingSessionType, string> = {
    [SimulatorTrainingSessionType.VirtualClassroom]: t(
      `${I18_PATH}.scheduleVirtualClassroomSession.virtualClassroomSession`
    ),
    [SimulatorTrainingSessionType.SimulatorEnvironment]: t(
      `${I18_PATH}.scheduleSimulatorSession.simulatorSession`
    ),
  }

  return (
    <SessionList>
      {sessions.map(session => {
        const { sessionId, type } = session
        if (type === SimulatorTrainingSessionType.SimulatorEnvironment) {
          return (
            <ScheduleSimulatorSessionContainer
              key={sessionId}
              session={session}
              sessionTypes={sessionTypes}
              onStartSimulation={onStartSimulation}
              onStopSimulation={onStopSimulation}
            />
          )
        }
        return (
          <ScheduleVirtualClassroomSession
            key={sessionId}
            session={session}
            sessionTypes={sessionTypes}
            onStart={onStart}
          />
        )
      })}
    </SessionList>
  )
}

export default ScheduleSessions
